import { render, staticRenderFns } from "./InspectionArchDiagram.vue?vue&type=template&id=352e06b6&scoped=true"
import script from "./InspectionArchDiagram.vue?vue&type=script&lang=js"
export * from "./InspectionArchDiagram.vue?vue&type=script&lang=js"
import style0 from "./InspectionArchDiagram.vue?vue&type=style&index=0&id=352e06b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e06b6",
  null
  
)

export default component.exports